// extracted by mini-css-extract-plugin
module.exports = {"banner":"jam-banner-module--banner--3ftgr"};